import React from 'react';

export const defaultUserContext = {

};

export const UserContext = React.createContext(defaultUserContext);
